interface NoneProps {
    color?: string;
    width?: number;
    height?: number;
}

const None: React.FC<NoneProps> = ({ color = "#3F3F3F", width = 16, height = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
            <path d="M1 1L15 15" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2.39355 3.80762C1.51829 4.97622 1 6.42762 1 8C1 11.866 4.13401 15 8 15C9.57231 15 11.0228 14.4807 12.1914 13.6055L12.9033 14.3174C11.5487 15.3703 9.8486 16 8 16C3.58172 16 0 12.4183 0 8C0 6.15134 0.628633 4.45037 1.68164 3.0957L2.39355 3.80762ZM8 0C12.4183 0 16 3.58172 16 8C16 9.8486 15.3703 11.5487 14.3174 12.9033L13.6055 12.1914C14.4807 11.0228 15 9.57231 15 8C15 4.13401 11.866 1 8 1C6.42762 1 4.97622 1.51829 3.80762 2.39355L3.0957 1.68164C4.45037 0.628633 6.15134 0 8 0Z" fill={color}/>
        </svg>
    );
};

export default None;